/* German copy. Mirrors the namespaces in ./en.js exactly. */
const de = {
  common: {
    skipToContent: "Zum Inhalt springen",
    home: "Startseite",
    languageLabel: "Sprache ändern",
    site: {
      tagline: "KI-gestütztes Source-to-Pay für Unternehmen",
      description:
        "Mercoris ist die KI-gestützte Source-to-Pay-Plattform für die Unternehmensbeschaffung: Lieferantenmanagement, Sourcing, Verträge, Rechnungen und Ausgabenanalysen auf einer Low-Code-Grundlage.",
      shortPitch: "KI-gestütztes Source-to-Pay für Unternehmen, die Geschwindigkeit wollen, ohne die Kontrolle abzugeben.",
      offices: {
        unitedStates: "USA",
        germany: "Deutschland",
        india: "Indien",
      },
    },
    footer: {
      legal: "Alle Rechte vorbehalten.",
      columns: {
        sitemap: "Sitemap",
        sourceToPay: "Source to Pay",
        solutions: "Lösungen",
        platform: "Plattform",
      },
      viewAllApps: "Alle Apps ansehen →",
    },
  },

  nav: {
    primary: {
      home: "Startseite",
      s2p: "Source to Pay",
      solutions: "Lösungen",
      platform: "Plattform",
      about: "Über uns",
      contact: "Kontakt",
    },
    viewAll: "Alle ansehen →",
    mobileOverview: "Übersicht: {{title}}",
    menus: {
      s2p: {
        kicker: "Source to Pay",
        title: "Source-to-Pay-Suite",
        blurb:
          "Ein durchgängiger Ablauf vom Sourcing-Ereignis bis zur beglichenen Rechnung — jedes Modul KI-gestützt, prüfungsbereit und ab Tag eins live.",
        groups: {
          vendorManagement: {
            heading: "Lieferantenmanagement",
            sub: "Transformieren Sie das Lieferantenmanagement mit KI-gestützten Apps.",
          },
          other: {
            heading: "Weitere Source-to-Pay-Apps",
            sub: "Apps für Verträge, Compliance, Leistung, Risiko und Lieferantenkommunikation.",
          },
        },
      },
      solutions: {
        kicker: "Lösungen",
        title: "Lösungen",
        blurb:
          "Ergebnisorientierte Programme für Einkaufs-, Finanz- und Betriebsteams, die ihre Arbeitsweise modernisieren.",
      },
      platform: {
        kicker: "Plattform",
        title: "Die Mercoris-Plattform",
        blurb:
          "Eine Low-Code-Grundlage, die Ihre Teams selbst erweitern — Builder, Daten, KI und Kontrollen auf Enterprise-Niveau.",
      },
    },
    items: {
      "vendor-onboarding": { label: "Lieferanten-Onboarding", blurb: "Selbstständige Registrierung" },
      "purchase-requisition": { label: "Bestellanforderung", blurb: "Geführte Erfassung und Freigaben" },
      "purchase-order": { label: "Bestellung", blurb: "Automatisierte Bestellausgabe" },
      "e-auctions": { label: "E-Auktionen", blurb: "Live-Wettbewerbsgebote" },
      "request-for-quotation": { label: "Angebotsanfrage", blurb: "Strukturierte Sourcing-Ereignisse" },
      "goods-receipt-note": { label: "Wareneingang", blurb: "Erfassung von Eingang und Qualität" },
      invoice: { label: "Rechnung", blurb: "Automatischer Drei-Wege-Abgleich" },
      "digital-transformation": { label: "Digitale Transformation", blurb: "Papier- und E-Mail-Prozesse ablösen" },
      "workflow-automation": { label: "Workflow-Automatisierung", blurb: "Regeln, Routing und SLAs" },
      "case-management": { label: "Fallmanagement", blurb: "Strukturierte Problemlösung" },
      marketplace: { label: "Marktplatz", blurb: "Kuratiertes Katalog-Einkaufen" },
      "procurement-automation": { label: "Einkaufsautomatisierung", blurb: "Von der Anforderung bis zur Zahlung" },
      "vendor-management": { label: "Lieferantenmanagement", blurb: "Lebenszyklus in einem System" },
      "supply-chain-management": { label: "Supply-Chain-Management", blurb: "Transparenz über alle Ebenen" },
      "low-code-app-builder": { label: "Low-Code-App-Builder", blurb: "Interne Apps in Tagen bereitstellen" },
      "form-builder": { label: "Formular-Builder", blurb: "Datenerfassung per Drag-and-Drop" },
      "workflow-builder": { label: "Workflow-Builder", blurb: "Visuelle Prozessgestaltung" },
      "dashboard-reports": { label: "Dashboard & Berichte", blurb: "Operative Berichterstattung" },
      analytics: { label: "Analytics", blurb: "Selbstständige Datenauswertung" },
      "ai-engine": { label: "KI-Engine", blurb: "Agenten, Extraktion, Erkenntnisse" },
      "api-integrations": { label: "API & Integrationen", blurb: "ERP und Best-of-Breed" },
      "role-management": { label: "Rollenverwaltung", blurb: "Granulare Berechtigungen" },
      "service-entry-sheet": { label: "Leistungserfassungsblatt" },
      "advance-shipping-notice": { label: "Vorabversandbenachrichtigung" },
      "contract-management": { label: "Vertragsmanagement" },
      "supplier-certification": { label: "Lieferantenzertifizierung" },
      "supply-chain-issue-management": { label: "Störungsmanagement in der Lieferkette" },
      "supplier-rating": { label: "Lieferantenbewertung" },
      "supplier-compliance-management": { label: "Lieferanten-Compliance-Management" },
      "supplier-performance-management": { label: "Lieferantenleistungsmanagement" },
      "supplier-bulletin-management": { label: "Lieferanten-Mitteilungsmanagement" },
    },
  },

  home: {
    hero: {
      badge: "✦ Neue bahnbrechende KI-Plattform",
      title: "Der KI-gestützte Low-Code- und No-Code-Kern für Unternehmensinnovation",
      lede: "Mercoris Core ist die grundlegende KI-Engine, die jede App, jeden Workflow und jede Integration auf unserer Plattform antreibt. Sie bietet die essenzielle Infrastruktur für schnelle, codefreie Entwicklung und verwandelt komplexe Geschäftslogik in leistungsstarke digitale Werte.",
      bookDemo: "Demo buchen",
      explorePlatform: "Plattform entdecken",
      mockTitle: "Ausgaben-Kommandozentrale",
      mockPill: "KI-Engine aktiv",
      cycleTimeTitle: "Durchlaufzeit nach Phase",
      aiActionsTitle: "KI-Aktionen heute",
    },
    heroStats: [
      { label: "Adressierbare Ausgaben", value: "4,2 Mrd. €", delta: "94 % unter Verwaltung" },
      { label: "Anforderung → Bestellung", value: "1,4 T", delta: "↓ 71 % im Jahresvergleich" },
      { label: "Automatische Rechnungen", value: "88 %", delta: "↑ 23 Pkt. seit KI-Engine" },
      { label: "Aktive Lieferanten", value: "12.480", delta: "99,1 % compliant" },
    ],
    cycleBars: [
      { label: "Erfassung" },
      { label: "Sourcing" },
      { label: "Vergabe" },
      { label: "Bestellung" },
      { label: "Wareneingang" },
      { label: "Rechnung" },
      { label: "Zahlung" },
    ],
    aiActions: [
      { title: "1.204 Rechnungen mit Bestellung und Wareneingang abgeglichen", meta: "Ausnahmen an 3 Genehmiger weitergeleitet" },
      { title: "Doppelzahlungsrisiko erkannt — 48.200 €", meta: "Lieferant: Kernwerk GmbH · zurückgehalten" },
      { title: "RFQ für C-Teile entworfen", meta: "9 qualifizierte Lieferanten vorgeschlagen" },
      { title: "Verlängerungshinweis: 12 Verträge in 30 Tagen", meta: "Geschätzt vermiedener Verlust: 310.000 $" },
    ],
    trustedBy: "Vertraut von",
    certs: {
      title: "Ihr Unternehmen ist",
      titleAccent: "bei uns sicher",
      lede: "Mercoris erfüllt anerkannte Zertifizierungen und unterstreicht damit unser Engagement für Datenschutz, Qualitätsmanagement und Sicherheitsstandards.",
      gdpr: "DSGVO",
      gdprLabel: "Konform",
      tisax: "TISAX",
      tisaxLabel: "Konform",
      isoStandards: ["ISO 9001", "ISO 27001", "ISO 27034", "ISO 12207", "ISO 22301", "ISO 20000"],
    },
    why: {
      kicker: "Warum Mercoris",
      title: "Gemacht für die komplexe Realität des Unternehmenseinkaufs",
      lede: "Die meisten Procurement-Suiten zwingen Ihren Prozess in ihre Vorlage. Mercoris passt sich Ihrem Prozess an — mit Low-Code-Konfiguration, KI, die Ihre Dokumente liest, und Kontrollen, die Ihre Prüfer bereits kennen.",
    },
    whyCards: [
      { title: "Konfigurieren statt anpassen lassen", body: "Formulare, Workflows und Freigaben ändern sich im Browser. Keine Berater, keine Upgrade-Schulden, wenn sich der Prozess ändert." },
      { title: "Eine einzige Lieferantenwahrheit", body: "Qualifikation, Compliance, Leistung und Ausgaben leben auf einem einzigen Lieferantendatensatz, der über alle Module hinweg geteilt wird." },
      { title: "KI, die einer Prüfung standhält", body: "Jede Extraktion, Empfehlung und automatisierte Aktion zeigt ihre Nachweise und kann mit einem Klick rückgängig gemacht werden." },
      { title: "Einführung in Wochen", body: "Beginnen Sie mit einer Kategorie oder einem Modul. Erweitern Sie über Gesellschaften hinweg ohne Plattformwechsel oder Zweitvertrag." },
    ],
    ai: {
      kicker: "KI-Fähigkeiten",
      title: "Eine KI-Engine, die die Beschaffungs-Routinearbeit erledigt",
      lede: "Dokumentenintelligenz, Anomalieerkennung und agentenbasierte Workflows arbeiten in Ihrem Prozess — nicht daneben. Jede KI-Aktion ist erklärbar, umkehrbar und protokolliert.",
      link: "KI-Engine ansehen",
    },
    aiCapabilities: [
      { title: "Dokumentenintelligenz", body: "Rechnungen, Verträge, Zertifikate und Angebote werden mit Konfidenzbewertung in strukturierte Felder überführt." },
      { title: "Autonomer Abgleich", body: "Drei-Wege-Abgleich, Toleranzbehandlung und Ausnahme-Routing ohne Tastendruck bei sauberen Transaktionen." },
      { title: "Risiko- und Anomalieerkennung", body: "Doppelzahlungen, Preisabweichungen, gesplittete Bestellungen und Sanktionsrisiken werden erkannt, bevor sie sich auswirken." },
      { title: "Sourcing-Copilot", body: "RFQs entwerfen, qualifizierte Lieferanten vorschlagen und Angebotsvergleiche in Ihrer eigenen Geschäftssprache zusammenfassen." },
      { title: "Konversationelle Analytik", body: "Fragen Sie nach Ausgaben nach Kategorie, Gesellschaft oder Lieferant und erhalten Sie eine belastbare Antwort samt zugrunde liegender Abfrage." },
    ],
    s2p: {
      kicker: "Source to Pay",
      title: "Der gesamte Source-to-Pay-Lebenszyklus. Gebaut für Skalierung, Compliance und Kontrolle",
      link: "Vollständige Source-to-Pay-Tour",
      appsPanelTitle: "Zweckgebundene Apps,",
      appsPanelRest: "die den gesamten Procure-to-Pay-Ablauf abdecken",
      buildTitle: "Möchten Sie Ihre eigene App bauen?",
      buildLine: "Betreiben Sie sie mit unserer KI-basierten Plattform zur Geschäftsprozessautomatisierung.",
      capsPanelTitle: "Kernfähigkeiten,",
      capsPanelRest: "verfügbar in jeder App",
      supplierPanelTitle: "Lieferantenseitige Apps",
      supplierPanelRest: "für den gesamten Lieferantenlebenszyklus",
    },
    coreApps: [
      { label: "Lieferanten-Onboarding" },
      { label: "Bestellanforderung" },
      { label: "Angebotsanfrage" },
      { label: "Vertragsmanagement" },
      { label: "Rückwärts-/Vorwärtsauktion" },
      { label: "Bestellungen" },
      { label: "Vorabversandbenachrichtigung" },
      { label: "Rechnung" },
    ],
    supplierApps: [
      { label: "Wareneingang" },
      { label: "Leistungserfassungsblatt" },
      { label: "Lieferanten-Mitteilungsmanagement" },
      { label: "Lieferanten-Compliance-Management" },
      { label: "Lieferantenleistungsmanagement" },
      { label: "Störungsmanagement in der Lieferkette" },
      { label: "Lieferantenzertifizierung" },
      { label: "Lieferantenbewertung" },
    ],
    capabilities: [
      { label: "Integration mit mehreren ERP-Systemen" },
      { label: "Vollständig konfigurierbar, ohne Code" },
      { label: "2- und 3-Wege-Abgleich" },
      { label: "Governance & Compliance" },
      { label: "OCR + Kreditorenbuchhaltungs-Automatisierung" },
      { label: "Dashboards & Analytics" },
    ],
    buildStats: [
      { value: "10x", label: "Zeit und Aufwand der Mitarbeitenden sparen" },
      { value: "↓ TCO", label: "Niedrige Gesamtbetriebskosten" },
      { value: "Flexibel", label: "Einfach zu konfigurieren und zu nutzen" },
    ],
    solutions: {
      kicker: "Lösungen",
      title: "Lösungen, aufgebaut um das Ergebnis, das Sie anstreben",
      lede: "Wählen Sie das Problem — langsame Freigaben, Lieferantenrisiko, Ausgaben außerhalb des Vertrags — und Mercoris konfiguriert die Module, Workflows und Berichte, die es lösen.",
      link: "Lösungen entdecken",
    },
    solutionCards: {
      "digital-transformation": { body: "E-Mail-Freigaben und geteilte Laufwerke durch ein einziges, kontrolliertes System ablösen.", outcome: "60 % weniger manueller Aufwand" },
      "workflow-automation": { body: "Regeln, Routing, Eskalationen und SLAs visuell gestaltet und sicher versioniert.", outcome: "4x schnellere Freigaben" },
      "case-management": { body: "Lieferantenanfragen, Rechnungsstreitigkeiten und Ausnahmen mit Verantwortlichen und Fristen bearbeiten.", outcome: "Lösung in Stunden" },
      marketplace: { body: "Kuratierte Kataloge und Punchout, damit Einkäufer innerhalb der Richtlinie selbst bestellen.", outcome: "92 % vertragskonformer Einkauf" },
      "procurement-automation": { body: "Von der Anforderung bis zur Zahlung, mit KI für die sich wiederholende Mitte.", outcome: "0,94 $ pro Rechnung" },
      "vendor-management": { body: "Ein Lebenszyklus von der Qualifikation bis zur Leistungsbewertung und zum Offboarding.", outcome: "99 % Compliance-Quote" },
      "supply-chain-management": { body: "Transparenz über Lieferanten, Ebenen und Verpflichtungen, bevor eine Störung eintritt.", outcome: "Risiko 30 Tage im Voraus erkannt" },
    },
    platform: {
      kicker: "Plattform",
      title: "Low-Code im Kern. Enterprise-Niveau durchgängig",
      lede: "Mercoris wird als funktionsfähige S2P-Suite ausgeliefert und bleibt dauerhaft konfigurierbar. Ihr Team baut Formulare, Workflows, Dashboards und Apps, ohne auf einen Release-Zyklus zu warten.",
      link: "Plattform-Tour starten",
    },
    features: {
      kicker: "Kernfunktionen",
      title: "Die Details, die über die Einführung entscheiden",
    },
    featureCards: [
      { title: "Mehrere Gesellschaften, mehrere Währungen", body: "Rechtsträger, Steuerregeln, Währungen und Sprachen in einem einzigen Mandanten verwaltet." },
      { title: "Richtlinienbewusste Freigaben", body: "Vollmachten, Schwellenwerte und Funktionstrennung automatisch durchgesetzt." },
      { title: "Lieferantenportal", body: "Lieferanten registrieren sich, reichen Dokumente ein, bieten und verfolgen Zahlungen selbst." },
      { title: "Vertragsintelligenz", body: "Klauselextraktion, Verpflichtungsverfolgung und Verlängerungshinweise über das gesamte Repository." },
      { title: "Budgetprüfungen", body: "Echtzeit-Verpflichtungs- und Budgetvalidierung, bevor eine Anforderung genehmigt wird." },
      { title: "Mobile Freigaben", body: "Vom Smartphone aus genehmigen, ablehnen oder nachfragen — mit vollständigem Prüfkontext." },
      { title: "Konfigurierbare Scorecards", body: "Gewichtete Lieferanten-KPIs mit automatischer Datenerfassung und Prüfrhythmus." },
      { title: "Unveränderlicher Prüfpfad", body: "Jede Feldänderung, Freigabe und KI-Aktion mit Zeitstempel versehen und exportierbar." },
    ],
    outcomeStats: [
      { to: 71, suffix: "%", label: "Schnellere Anforderung-zu-Bestellung", note: "Median über Enterprise-Einführungen im ersten Jahr." },
      { to: 88, suffix: "%", label: "Automatische Rechnungsquote", note: "Durchgängige Verarbeitung bei aktivierter KI-Engine." },
      { to: 4.2, prefix: "$", suffix: " Mrd.", label: "Verwaltete Ausgaben", note: "Über Fertigung, Energie, Pharma und öffentlichen Sektor hinweg." },
      { to: 6, suffix: " Wo.", label: "Typische Zeit bis zum ersten Go-Live", note: "Eine Kategorie live, bevor das gesamte Programm startet." },
    ],
    about: {
      kicker: "Über uns",
      title: "Enterprise-Beschaffungsplattformen für komplexe Unternehmen entwickeln",
      lede: "Mercoris entwickelt und betreibt eine einzige Source-to-Pay-Plattform für Organisationen, in denen jedes System echtes operatives und regulatorisches Gewicht trägt — unterstützt von erfahrenen Teams und 24/7-Support in den USA, Deutschland und Indien.",
      link: "Mehr über uns",
    },
    aboutStats: [
      { value: "3", label: "Lieferregionen — USA, Deutschland, Indien" },
      { value: "24/7", label: "Technologen und Allianzexperten" },
      { value: "16", label: "Source-to-Pay-Apps in der Suite" },
      { value: "200+", label: "Bisher betreute Unternehmen" },
    ],
    cta: {
      title: "Erleben Sie Mercoris an Ihrem eigenen Prozess",
      lede: "Eine 30-minütige Arbeitssitzung mit einem Procurement-Architekten — wir bilden eine Ihrer laufenden Kategorien end-to-end ab und zeigen genau, was sich durch Automatisierung ändert.",
      bookDemo: "Demo buchen",
      talkToSales: "Mit dem Vertrieb sprechen",
    },
    contact: {
      kicker: "Kontakt",
      title: "Transformieren Sie Ihre",
      titleLine2: "Beschaffungsstrategie",
      lede: "Möchten Sie sehen, wie Mercoris zu Ihren Geschäftsanforderungen passt, oder eine kurze Demo erleben? Sprechen Sie mit uns.",
      link: "Kontaktformular öffnen",
      emailLabel: "E-Mail",
      emailNote: "Demos, Preise und Pilotprojekte — Antwort innerhalb eines Werktags",
    },
  },

  about: {
    hero: {
      title: "Wir entwickeln Beschaffungssoftware",
      titleLine2: "für Menschen, die das Problem selbst erlebt haben",
      lede: "Mercoris wurde von Einkaufspraktikern und Plattform-Ingenieuren gegründet, die jahrelang mit ansehen mussten, wie gute Teams von unflexibler Software ausgebremst wurden. Also haben wir eine gebaut, die sich anpasst.",
      breadcrumb: "Über uns",
    },
    facts: [
      { value: "2019", label: "Gegründet, Hauptsitz in Leander, TX, USA" },
      { value: "4,2 Mrd. $", label: "Unternehmensausgaben auf der Plattform verwaltet" },
      { value: "5", label: "Datenresidenz-Regionen im Produktivbetrieb" },
      { value: "12.480", label: "Lieferanten, die über Mercoris Transaktionen abwickeln" },
    ],
    company: {
      kicker: "Unternehmensüberblick",
      title: "Enterprise-Beschaffungsplattformen für komplexe Unternehmen entwickeln",
    },
    overviewStats: [
      { value: "3", label: "Lieferregionen — USA, Deutschland, Indien" },
      { value: "24/7", label: "Technologen und Allianzexperten" },
      { value: "16", label: "Source-to-Pay-Apps in der Suite" },
      { value: "200+", label: "Bisher betreute Unternehmen" },
    ],
    overviewTags: [
      "Produktentwicklung",
      "Plattformimplementierung",
      "ERP-Integration",
      "Anwendungsmanagement",
      "KI-Befähigung",
    ],
    overviewParagraphs: [
      "Mercoris entwickelt Unternehmensprodukte für Organisationen aus Fertigung, Energie, Pharma, Logistik und dem öffentlichen Sektor — Umgebungen, in denen jedes System echtes operatives und regulatorisches Gewicht trägt.",
      "Unsere Produktlinie konzentriert sich auf eine einzige Plattform: eine vollständige Source-to-Pay-Suite auf Low-Code-Basis, mit einer KI-Engine für Umgebungen, in denen jede automatisierte Entscheidung erklärbar sein muss. Darum herum bieten wir Implementierung, Integration und Anwendungsmanagement, damit jeder Kunde live geht — und es bleibt.",
      "Wir arbeiten in kleinen, erfahrenen Teams, unterstützt von Technologen und Allianzpartnern, die rund um die Uhr verfügbar sind. Jeder Kunde erhält einen benannten Architekten, der seine Landschaft, sein ERP und seine Prüfpflichten versteht — keine Ticket-Warteschlange.",
    ],
    mission: {
      kicker: "Unsere Mission",
      body: "Der Kernzweck von Mercoris ist es, Unternehmen mit modernsten Technologielösungen zu befähigen, komplexe Geschäftsprobleme zu lösen. Wir brennen für Innovation und nutzen sie, um Unternehmenswachstum und Erfolg zu ermöglichen.",
      points: [
        "Nachhaltiges digitales Wachstum vorantreiben",
        "Innovation für eine intelligentere Zukunft",
        "Kundenorientierte IT-Exzellenz",
        "Vernetzte, widerstandsfähige Ökosysteme aufbauen",
      ],
    },
    vision: {
      kicker: "Unsere Vision",
      body: "Unser Wertversprechen liegt in unserem Engagement, Qualität an erste Stelle zu setzen. Wir entwickeln ein erstklassiges Unternehmensprodukt, unterstützt von einem Team aus Technologen und Allianzpartnern, die rund um die Uhr verfügbar sind. Wir sind stolz darauf, ein vertrauenswürdiger Produktpartner für Unternehmen jeder Größe und Branche zu sein.",
      points: [
        "Engagement für Exzellenz",
        "Globale Partnerschaften stärken",
        "Kunden in den Mittelpunkt stellen",
      ],
    },
    valuesTitle: "Unsere Werte",
    values: [
      { title: "Praktiker zuerst", body: "Produktentscheidungen werden mit Menschen getroffen, die eine Kategorie geführt haben — nicht nur mit Menschen, die eine Roadmap geführt haben." },
      { title: "Konfiguration statt Anpassung", body: "Wenn ein Kunde Code ändern muss, betrachten wir das als Produktlücke — nicht als Servicechance." },
      { title: "Standardmäßig erklärbar", body: "Jede automatisierte Entscheidung muss ihre Nachweise zeigen können. Kann sie das nicht, wird sie nicht ausgeliefert." },
      { title: "Sicherheit ist keine Stufe", body: "Jede Kontrolle, die wir bauen, ist in jedem Plan und in jeder Region verfügbar, in der wir tätig sind." },
      { title: "Ehrlich zur Passgenauigkeit", body: "Wir sagen Interessenten, wenn eine Anforderung schlecht zu uns passt. Das kostet Aufträge und rettet Programme." },
      { title: "An Ergebnissen gemessen", body: "Erfolg bedeutet Durchlaufzeit, Compliance und realisierte Einsparungen — nicht ausgerollte Lizenzen." },
      { title: "Partner, keine Anbieter", body: "Wir bleiben nach dem Go-live am Konto, denn im zweiten Jahr entsteht der eigentliche Mehrwert." },
      { title: "Immer erreichbar, überall", body: "Technologen und Allianzexperten rund um die Uhr in unseren Teams in den USA, Deutschland und Indien." },
    ],
    why: {
      kicker: "Warum Mercoris",
      title: "Was Teams uns über den entscheidenden Unterschied erzählen",
    },
    whyCards: [
      { title: "Der Prozess passt sich uns an, nicht umgekehrt", body: "Freigabematrizen, Gesellschaftsregeln und Kategorielogik in Wochen konfiguriert, in Stunden geändert." },
      { title: "KI, die einer Prüfung standhält", body: "Jede Extraktion und jeder automatisierte Abgleich behält Nachweis, Konfidenzwert und Umkehrpfad." },
      { title: "Eine Plattform, nicht sieben zusammengeflickte Module", body: "Gemeinsames Datenmodell, gemeinsame Berechtigungen, gemeinsame Berichte — keine Integrationssteuer zwischen unseren eigenen Produkten." },
      { title: "Erfahrene Ansprechpartner am Konto", body: "Ein benannter Architekt, der Ihre ERP-Landschaft kennt und bei den schwierigen Gesprächen dabei ist." },
    ],
    enterprise: {
      kicker: "Enterprise-Fokus",
      title: "Wir sind auf die anspruchsvollsten Einführungen optimiert",
      lede: "Mehrere Gesellschaften, mehrere ERP-Systeme, tarifgebundene Standorte, regulierte Kategorien und ein Prüfungsausschuss, der jedes Detail liest. Für dieses Umfeld ist Mercoris gemacht.",
    },
    enterpriseFocus: [
      { title: "Mehrere Gesellschaften, mehrere ERP-Landschaften", body: "Konsolidierte Berichterstattung über Gesellschaften hinweg, die nie eine gemeinsame ERP-Instanz teilen werden." },
      { title: "Regulierte Kategorien", body: "Pharma-, Energie- und Regeln der öffentlichen Beschaffung unterstützt, ohne Individualcode." },
      { title: "Globale Lieferantenbasis", body: "Lokalisierte Portale, Steuerprüfung und Dokumentenanforderungen je Markt." },
      { title: "Ernsthafte Prüfpflichten", body: "Unveränderliche Protokolle, Funktionstrennung und Nachweispakete auf Abruf." },
      { title: "Gestufte Einführungen", body: "Kategorie-für-Kategorie-Einführung mit globaler Governance ab dem ersten Tag." },
    ],
    testimonialsSection: {
      kicker: "Referenzen",
      title: "Was unsere Kunden sagen",
      lede: "Erfahren Sie, wie unsere Kunden ihr Geschäft mit unseren innovativen IT-Lösungen und engagiertem Support transformiert haben.",
    },
    testimonials: [
      {
        quote: "Wir sind begeistert von der Workflow-Anwendung, die das Mercoris-Team entwickelt hat. Sie hat unsere Abläufe gestrafft und uns ermöglicht, Prozesse anzupassen, die am besten zu uns passen. Die Professionalität und Unterstützung des Teams waren außergewöhnlich. Wir empfehlen Mercoris für erstklassige Softwarelösungen und reibungslose Lieferung uneingeschränkt weiter.",
        role: "Director, EpicsAI",
      },
      {
        quote: "Wir sind mit der Partnerschaft mit Mercoris in der IT- und Prozessberatung für die Automobil- und Fertigungsindustrie äußerst zufrieden. Ihr Engagement für termingerechte Lieferung, Innovation und Qualitätsarbeit war bemerkenswert. Die Expertise und Zusammenarbeit von Mercoris haben unseren Betrieb und Erfolg immens bereichert.",
        role: "MEC Industries",
      },
      {
        quote: "Wir sind begeistert von Mercoris und ihren transformativen IT-Lösungen. Nach der Integration hat sich unsere Effizienz drastisch verbessert und manuelle Aufgaben wurden deutlich reduziert. Das Engagement, der Support und der maßgeschneiderte Ansatz des Teams waren herausragend. Wir empfehlen Mercoris jedem Unternehmen, das eine zuverlässige digitale Transformation sucht.",
        role: "Director, Koncepthouse",
      },
    ],
    certificationsSection: {
      kicker: "Zertifizierungen",
      title: "Unabhängig geprüft, jährlich",
    },
    certifications: [
      { name: "ISO 27001", note: "Informationssicherheits-Managementsystem, zertifiziert und jährlich überwacht." },
      { name: "SOC 2 Type II", note: "Unabhängige Prüfung der Kontrollen für Sicherheit, Verfügbarkeit und Vertraulichkeit." },
      { name: "ISO 9001", note: "Qualitätsmanagement über Produktentwicklung und Auslieferung hinweg." },
      { name: "DSGVO", note: "EU-Verarbeitung, AVVs und regionale Residenzoptionen." },
      { name: "WCAG 2.1 AA", note: "Barrierefreiheits-Konformität über Anwendung und Lieferantenportal hinweg." },
    ],
    cta: {
      title: "Stellen Sie uns auf die Probe",
      body: "Bringen Sie Ihre schwierigste Anforderung mit — die Steuerregel für mehrere Gesellschaften, das Alt-ERP, die Lieblingsfrage des Prüfers. Wir beantworten sie lieber jetzt als im sechsten Monat.",
      primaryLabel: "Mercoris kontaktieren",
    },
  },

  platform: {
    hero: {
      breadcrumb: "Plattform",
      title: "Die Plattform unter der Suite",
      lede: "Mercoris ist eine Low-Code-Anwendungsplattform, die zufällig mit einer vollständigen Source-to-Pay-Suite ausgeliefert wird. Alles, was Sie sehen, ist konfigurierbar — und alles, was Ihr Team baut, erbt dieselbe Sicherheits-, Prüf- und KI-Grundlage.",
      demoButton: "Technische Demo buchen",
      architectureButton: "Architektur ansehen",
    },
    blocks: {
      "low-code-app-builder": {
        kicker: "Low-Code-App-Builder",
        title: "Bauen Sie die App, die der Prozess wirklich braucht",
        body: "Datenmodelle, Bildschirme, Logik und Berechtigungen visuell zusammenstellen. Eine interne Anwendung in Tagen ausliefern, geregelt durch dieselben Kontrollen wie die Kernsuite.",
        bullets: ["Visuelle Datenmodellierung", "Bildschirm- und Layout-Designer", "Wiederverwendbare Komponentenbibliothek", "Umgebungsbeförderung mit Änderungsprotokollen"],
        panelTitle: "App-Designer",
        panelMeta: "Entwurf v4",
        rows: [
          { tag: "Entität", label: "Lieferantenanspruch", value: "12 Felder" },
          { tag: "Bildschirm", label: "Anspruchserfassung", value: "responsiv" },
          { tag: "Logik", label: "Automatische Zuweisung nach Region", value: "aktiv" },
          { tag: "Zugriff", label: "Einkäufer, Finanzen, Admin", value: "3 Rollen" },
        ],
      },
      "form-builder": {
        kicker: "Formular-Builder",
        title: "Drag-and-Drop-Erfassung mit echter Validierung",
        body: "Erstellen Sie Formulare, die die Datenqualität bei der Eingabe sicherstellen — bedingte Felder, Abgleich mit Stammdaten, Dateierfassung und mehrsprachige Beschriftungen.",
        bullets: ["Bedingte Feldlogik", "Stammdatenabgleiche", "Datei- und Unterschriftserfassung", "Lokalisierung je Markt"],
        panelTitle: "Formular: Lieferantenanfrage",
        panelMeta: "veröffentlicht",
        rows: [
          { tag: "Feld", label: "Steuer-ID", value: "validiert" },
          { tag: "Feld", label: "Bankdaten", value: "verschlüsselt" },
          { tag: "Regel", label: "Anzeigen wenn Land = DE", value: "aktiv" },
          { tag: "Ausgabe", label: "Erstellt Lieferantenentwurf", value: "zugeordnet" },
        ],
      },
      "workflow-builder": {
        kicker: "Workflow-Builder",
        title: "Prozessgestaltung, die Ihre Fachanalysten selbst verantworten können",
        body: "Zustände, Übergänge, parallele Zweige, Timer und Eskalationen auf einer visuellen Oberfläche — mit einer Sandbox zum Testen, bevor etwas in Produktion geht.",
        bullets: ["Parallele und bedingte Verzweigungen", "SLA-Timer und Eskalationspfade", "Delegations- und Vertretungsregeln", "Versionierung mit sicherem Rollback"],
        panelTitle: "Workflow: Anforderungsfreigabe",
        panelMeta: "v7 · live",
        rows: [
          { tag: "Schritt 1", label: "Budgetprüfung", value: "automatisch" },
          { tag: "Schritt 2", label: "Vorgesetzter", value: "8-Std.-SLA" },
          { tag: "Schritt 3", label: "Finanzen > 10.000 €", value: "bedingt" },
          { tag: "Schritt 4", label: "Bestellerstellung", value: "automatisch" },
        ],
      },
      "dashboard-reports": {
        kicker: "Dashboard & Berichte",
        title: "Operative Antworten ohne Ticket",
        body: "Rollenbasierte Dashboards für Einkäufer, Genehmiger, Kreditorenbuchhaltung und Führungskräfte, plus geplante Berichte im jeweils passenden Format.",
        bullets: ["Rollenbasierte Dashboard-Vorlagen", "Drill-through zu Transaktionen", "Geplante E-Mail- und Dateizustellung", "Export nach Excel, CSV und PDF"],
        panelTitle: "Dashboard: Kreditorenbuchhaltung",
        panelMeta: "live",
        rows: [
          { tag: "Widget", label: "Rechnungen in Ausnahme", value: "178" },
          { tag: "Widget", label: "Über 30 Tage überfällig", value: "24" },
          { tag: "Widget", label: "Skonto gefährdet", value: "8.400 €" },
          { tag: "Zeitplan", label: "Täglich 07:00 MEZ", value: "an" },
        ],
      },
      analytics: {
        kicker: "Analytics",
        title: "Die Ausgabenfrage stellen, eine belastbare Antwort erhalten",
        body: "Eine semantische Schicht über den Beschaffungsdaten sorgt dafür, dass alle Einsparungen gleich berechnen — ob in der Oberfläche, in natürlicher Sprache oder in BI abgefragt.",
        bullets: ["Kontrollierte semantische Schicht", "Abfragen in natürlicher Sprache", "Kohorten- und Trendanalyse", "Warehouse-Synchronisierung mit Snowflake oder BigQuery"],
        panelTitle: "Erkunden: Ausgaben",
        panelMeta: "GJ26",
        rows: [
          { tag: "Dimension", label: "Kategorie / Gesellschaft", value: "gruppiert" },
          { tag: "Kennzahl", label: "Realisierte Einsparungen", value: "68,4 Mio. $" },
          { tag: "Filter", label: "Vertragslieferanten", value: "an" },
          { tag: "Export", label: "Snowflake-Freigabe", value: "stündlich" },
        ],
      },
      "ai-engine": {
        kicker: "KI-Engine",
        title: "Modelle mit Leitplanken, keine Spielereien",
        body: "Extraktion, Klassifizierung, Abgleich, Zusammenfassung und agentenbasierte Aktionen — jeweils mit Konfidenzschwellen, Human-Review-Pfaden und vollständigem Entscheidungsprotokoll.",
        bullets: ["Konfidenzschwellen je Prozess", "Human-in-the-Loop-Prüfwarteschlangen", "Vollständige Erklärbarkeit und Prüfprotokoll", "Keine Kundendaten für das Modelltraining verwendet"],
        panelTitle: "KI-Engine",
        panelMeta: "kontrolliert",
        rows: [
          { tag: "Modell", label: "Rechnungsextraktion", value: "99,2 % F1" },
          { tag: "Modell", label: "Ausgabenklassifizierung", value: "94 % Genauigkeit" },
          { tag: "Leitplanke", label: "Human Review < 0,85", value: "erzwungen" },
          { tag: "Protokoll", label: "Jede Aktion erfasst", value: "unveränderlich" },
        ],
      },
      "api-integrations": {
        kicker: "API & Integrationen",
        title: "Standardmäßig offen",
        body: "REST-APIs, Ereignis-Webhooks, dateibasierte Schnittstellen und zertifizierte ERP-Connectoren — mit Sandbox-Schlüsseln, Ratenbegrenzungen und Versionierung, wie Ihre Ingenieure es erwarten.",
        bullets: ["REST-API mit OpenAPI-Spezifikation", "Ereignis-Webhooks und Message-Queues", "Zertifizierte ERP-Connectoren", "SFTP-, EDI- und cXML-Schnittstellen"],
        panelTitle: "API-Konsole",
        panelMeta: "v2",
        rows: [
          { tag: "GET", label: "/v2/suppliers", value: "200 OK" },
          { tag: "POST", label: "/v2/requisitions", value: "201" },
          { tag: "Hook", label: "invoice.matched", value: "abonniert" },
          { tag: "Limit", label: "1.000 Anfragen / Min.", value: "Mandant" },
        ],
      },
      "role-management": {
        kicker: "Rollenverwaltung",
        title: "Berechtigungen, die Ihr Organigramm widerspiegeln",
        body: "Rollen, Gruppen, Gesellschaftsabgrenzung und feldgenaue Regeln — automatisch aus Ihrem Identity-Provider bereitgestellt und in einem Bildschirm überprüfbar.",
        bullets: ["Rollen- und Gruppenvererbung", "Gesellschafts- und Kategorieabgrenzung", "Feldgenaue Lese- und Schreibregeln", "SCIM-Provisionierung und Zugriffsprüfungen"],
        panelTitle: "Zugriffsmodell",
        panelMeta: "prüfbereit",
        rows: [
          { tag: "Rolle", label: "Kategorie-Einkäufer", value: "412 Nutzer" },
          { tag: "Bereich", label: "EMEA-Gesellschaften", value: "9 Gesellschaften" },
          { tag: "Regel", label: "Bankfelder ausgeblendet", value: "erzwungen" },
          { tag: "Prüfung", label: "Quartalsattestierung", value: "fällig in 12 T" },
        ],
      },
    },
    cta: {
      title: "Bringen Sie Ihre Architekten mit",
      body: "Wir führen Ihre Sicherheits-, Integrations- und Datenteams im Detail durch die Plattform — auch durch die Teile, die andere Anbieter auslassen.",
      primaryLabel: "Technische Demo buchen",
    },
  },

  solutions: {
    hero: {
      breadcrumb: "Lösungen",
      title: "Lösungen, aufgebaut um das Ergebnis, nicht um das Modul",
      lede: "Sieben Programme, die mit einem Problem beginnen, das Ihr Team bereits kennt, und mit einer Zahl enden, die Ihre Finanzabteilung überprüfen kann.",
    },
    items: {
      "digital-transformation": {
        title: "Digitale Transformation",
        summary: "Den Einkauf von E-Mail, Tabellen und geteilten Laufwerken auf ein einziges kontrolliertes System of Record verlagern — ohne Zweijahresprogramm.",
        problem: "Freigaben leben in Postfächern, die tatsächliche Lieferantenliste ist eine Tabelle, und niemand kann eine einfache Frage zu gebundenen Ausgaben beantworten, ohne dass drei Personen recherchieren.",
        approach: "Wir digitalisieren zuerst den Prozess mit der größten Reibung, belegen die Verbesserung der Kontrolle und übertragen dieselben Muster dann auf weitere Kategorien und Gesellschaften.",
        steps: [
          { title: "Ist-Zustand erfassen", body: "Zwei Wochen Prozessanalyse mit den Menschen, die die Arbeit tatsächlich erledigen." },
          { title: "Konfigurieren statt programmieren", body: "Formulare, Workflows und Freigaben im Browser gemäß Ihrer Richtlinie erstellt." },
          { title: "Migrieren und parallel betreiben", body: "Lieferantenstamm, offene Bestellungen und Verträge mit Validierungsberichten geladen." },
          { title: "Nach Gesellschaft skalieren", body: "Vorlage wiederverwenden, lokale Regeln anpassen, globale Berichterstattung intakt halten." },
        ],
        features: ["Zentrales System of Record", "Digitales Dokumentenarchiv", "Konfigurierbare Freigabematrix", "Change-Management-Toolkit", "Migration von Altdaten"],
        benefits: ["Eine einzige Quelle der Wahrheit", "Prüfnachweise auf Abruf", "Weniger Schattenprozesse", "Schnelleres Onboarding neuer Mitarbeitender"],
        outcomes: [{ value: "60 %", label: "Weniger manueller Aufwand" }, { value: "6 Wo.", label: "Bis zum ersten Go-live" }, { value: "100 %", label: "Transaktionen nachvollziehbar" }],
        ctaLabel: "Transformation planen",
        relatedLabel: "Low-Code-Plattform ansehen",
      },
      "workflow-automation": {
        title: "Workflow-Automatisierung",
        summary: "Freigabe- und Ausnahmeabläufe visuell gestalten, sicher versionieren und das System die SLA durchsetzen lassen statt einer Erinnerungs-E-Mail.",
        problem: "Jede Ausnahme wird zur Nachverfolgung. Genehmiger lassen Anfragen liegen, Eskalationen hängen davon ab, dass es jemand bemerkt, und niemand kann belegen, wo die Verzögerung entstand.",
        approach: "Den Prozess einmal im visuellen Builder modellieren, Regeln und SLAs anhängen und jedem Beteiligten eine Warteschlange mit klarer Verantwortung und Fristen geben.",
        steps: [
          { title: "Ablauf modellieren", body: "Zustände, Bedingungen, parallele Zweige und Delegation per Drag-and-Drop platzieren." },
          { title: "Regeln anhängen", body: "Schwellenwerte, Funktionstrennung, Toleranzen und Eskalationstimer." },
          { title: "In der Sandbox testen", body: "Reale Transaktionen simulieren, bevor etwas die Produktion erreicht." },
          { title: "Messen und feinjustieren", body: "Engpassanalysen zeigen, welcher Schritt als Nächstes zu beheben ist." },
        ],
        features: ["Visueller Workflow-Designer", "Bedingtes und paralleles Routing", "SLA-Timer und Eskalationen", "Delegation und Abwesenheitsregelung", "Versionskontrolle mit Rollback"],
        benefits: ["Vorhersehbare Durchlaufzeiten", "Weniger Eskalations-E-Mails", "Richtlinie automatisch durchgesetzt", "Klare Verantwortlichkeit je Schritt"],
        outcomes: [{ value: "4x", label: "Schnellere Freigaben" }, { value: "92 %", label: "Innerhalb der SLA" }, { value: "0", label: "Manuelle Nachverfolgungslisten" }],
        ctaLabel: "An Ihrem Prozess zeigen",
        relatedLabel: "Workflow-Builder",
      },
      "case-management": {
        title: "Fallmanagement",
        summary: "Lieferantenanfragen, Rechnungsstreitigkeiten und Qualitätsprobleme in nachverfolgte Fälle mit Verantwortlichen, Fristen und Lösungshistorie verwandeln.",
        problem: "Streitfälle wandern zwischen Kreditorenbuchhaltung, Einkäufern und Lieferant hin und her — ohne Ticket, ohne Verantwortlichen und ohne Aufzeichnung —, bis die Beziehung oder der Zahlungslauf darunter leidet.",
        approach: "Strukturierte Falltypen erfassen das Problem, leiten es an die richtige Stelle weiter, ziehen den Transaktionskontext hinzu und schließen mit einem dokumentierten Ergebnis ab.",
        steps: [
          { title: "Erfassen", body: "Fälle werden aus dem Portal, einer Rechnung, einem Wareneingang oder einer E-Mail angelegt." },
          { title: "Weiterleiten", body: "Zuweisung nach Typ, Kategorie, Gesellschaft und Arbeitslast." },
          { title: "Lösen", body: "Vollständiger Transaktionskontext und Nachrichten in einem Thread." },
          { title: "Lernen", body: "Ursachenkennzeichnung fließt in Lieferanten-Scorecards und Prozessverbesserungen ein." },
        ],
        features: ["Konfigurierbare Falltypen", "Lieferantengerichtete Nachrichten", "SLA-Uhren und Prioritäten", "Ursachentaxonomie", "Wissensdatenbank zur Lösung"],
        benefits: ["Nichts geht verloren", "Lieferanten hören auf, Einkäufer anzurufen", "Wiederkehrende Probleme werden behoben", "Nachweise für Verhandlungen"],
        outcomes: [{ value: "8 Std.", label: "Median Lösungszeit" }, { value: "-46 %", label: "Wiederkehrende Streitfälle" }, { value: "100 %", label: "Fälle prüfbar" }],
        ctaLabel: "Fallbearbeitung besprechen",
        relatedLabel: "Rechnungsmanagement",
      },
      marketplace: {
        title: "Marktplatz",
        summary: "Einkäufern einen kuratierten internen Katalog mit Vertragspreisen, Punchout zu Lieferantenseiten und vorab angewendeter Richtlinie geben.",
        problem: "Einkäufer kaufen außerhalb des Vertrags ein, weil das genehmigte Produkt schwerer zu finden ist als eine formlose Anfrage zu stellen — und Einsparungen versickern Bestellung für Bestellung.",
        approach: "Ein Einkaufserlebnis, das Ihre Mitarbeitenden wiedererkennen, verbunden mit Vertragskatalogen, Punchout-Partnern und den dahinterliegenden Freigaberegeln.",
        steps: [
          { title: "Kataloge laden", body: "Vertragsartikel, Preisdateien und Punchout-Verbindungen eingebunden." },
          { title: "Richtlinie anwenden", body: "Bevorzugte Lieferanten, Ausgabenlimits und Kategorieregeln je Gesellschaft." },
          { title: "Selbstbedienung aktivieren", body: "Suchen, vergleichen, in den Warenkorb legen und in unter einer Minute einreichen." },
          { title: "Versickerung schließen sehen", body: "Anfragen außerhalb des Katalogs werden mit der Vertragsalternative markiert." },
        ],
        features: ["Verwaltung interner Kataloge", "cXML-Punchout", "Durchsetzung von Vertragspreisen", "Steuerung bevorzugter Lieferanten", "Geführte Freitext-Erfassung"],
        benefits: ["Höherer vertragskonformer Einkauf", "Weniger eigenmächtige Käufe", "Zufriedenere Anforderer", "Sauberere Ausgabendaten"],
        outcomes: [{ value: "92 %", label: "Vertragskonformer Einkauf" }, { value: "-38 %", label: "Freitextanfragen" }, { value: "< 1 Min.", label: "Bis zur Bestellung" }],
        ctaLabel: "Katalog-Demo ansehen",
        relatedLabel: "Bestellanforderung",
      },
      "procurement-automation": {
        title: "Einkaufsautomatisierung",
        summary: "Die sich wiederholende Mitte des Procure-to-Pay automatisieren, damit das Team seine Zeit auf Kategoriestrategie und Lieferantenbeziehungen verwendet.",
        problem: "Erfahrene Einkaufsmitarbeitende verbringen ihre Woche mit erneuter Dateneingabe, Dokumentenabgleich und der Beantwortung von Statusfragen, die ein System beantworten sollte.",
        approach: "KI übernimmt Extraktion, Abgleich und Routinekommunikation; Menschen übernehmen Ermessensentscheidungen. Konfidenzschwellen halten Sie in Kontrolle über die Grenze.",
        steps: [
          { title: "Aufwand als Basislinie erfassen", body: "Wo die manuellen Eingriffe liegen und was jeder davon heute kostet." },
          { title: "Den sauberen Pfad automatisieren", body: "Durchgängige Verarbeitung für Transaktionen innerhalb der Toleranz." },
          { title: "Ausnahmen gestalten", body: "Klare Warteschlangen, Verantwortliche und Fristen für alles Übrige." },
          { title: "Schwellenwert anheben", body: "Automatisierung erweitern, sobald sich die Konfidenzdaten bewähren." },
        ],
        features: ["KI-Dokumentenextraktion", "Automatisierter Drei-Wege-Abgleich", "Auto-Bestellung aus genehmigten Anforderungen", "Selbstbedienung für Lieferantenstatus", "Verwaltung der Ausnahmewarteschlange"],
        benefits: ["Geringere Kosten pro Transaktion", "Schnellere Lieferantenzahlung", "Skonti erfasst", "Team auf Strategie umgestellt"],
        outcomes: [{ value: "88 %", label: "Automatische Rechnungen" }, { value: "0,94 $", label: "Kosten pro Rechnung" }, { value: "+23 Pkt.", label: "Skonto-Erfassung" }],
        ctaLabel: "Ihre Einsparungen modellieren",
        relatedLabel: "Rechnungsmanagement",
      },
      "vendor-management": {
        title: "Lieferantenmanagement",
        summary: "Den gesamten Lieferantenlebenszyklus — Qualifikation, Onboarding, Compliance, Leistung und Offboarding — aus einem Datensatz führen.",
        problem: "Lieferantendaten leben in vier Systemen, Compliance-Nachweise liegen in einem Ordner, den irgendjemand verwaltet, und Leistungsgespräche stützen sich auf Anekdoten.",
        approach: "Ein kontrolliertes Lieferantenprofil speist jedes Modul, mit automatisierter Überwachung und Scorecards aus tatsächlichen Transaktionsdaten.",
        steps: [
          { title: "Konsolidieren", body: "Doppelte Datensätze zusammenführen und mit ERP-Stammdaten abgleichen." },
          { title: "Qualifizieren", body: "Risikobasierte Fragebögen und Dokumentenvalidierung nach Kategorie." },
          { title: "Überwachen", body: "Laufende Prüfung von Compliance, Sanktionen und finanzieller Gesundheit." },
          { title: "Entwickeln", body: "Scorecards, Verbesserungspläne und strukturierte Geschäftsreviews." },
        ],
        features: ["Goldener Lieferantendatensatz", "Selbstbedienungs-Lieferantenportal", "Automatisierte Compliance-Überwachung", "Gewichtete Leistungs-Scorecards", "Offboarding-Workflow"],
        benefits: ["Vertrauenswürdige Lieferantendaten", "Geringeres Drittparteirisiko", "Objektive Leistungsbewertungen", "Schnellere Lieferanteneinrichtung"],
        outcomes: [{ value: "99 %", label: "Compliance-Quote" }, { value: "3 Tage", label: "Einladung bis aktiv" }, { value: "0,3 %", label: "Doppelte Datensätze" }],
        ctaLabel: "Ihre Lieferantenbasis prüfen",
        relatedLabel: "Modul Lieferanten-Onboarding",
      },
      "supply-chain-management": {
        title: "Supply-Chain-Management",
        summary: "Verpflichtungen, Abhängigkeiten und Risiken über Lieferanten und Ebenen hinweg früh genug erkennen, um zu handeln.",
        problem: "Störungen kommen als Anruf. Single-Source-Abhängigkeiten und Konzentrationsrisiken werden erst sichtbar, wenn eine Linie bereits stillsteht.",
        approach: "Bestellverpflichtungen, Lieferantenrisikosignale und Kategoriekonzentration in einer Ansicht kombinieren, mit Alarmen auf Frühindikatoren.",
        steps: [
          { title: "Abhängigkeiten abbilden", body: "Welche Lieferanten, Standorte und Kategorien kritisches Volumen tragen." },
          { title: "Signale erfassen", body: "Lieferleistung, finanzielle Gesundheit, Geografie und Nachrichtenereignisse." },
          { title: "Schwellenwerte setzen", body: "Alarme bei Konzentration, Vorlaufzeitabweichung und Bestätigungslücken." },
          { title: "Alternativen planen", body: "Qualifizierte Ausweichlieferanten bereit, bevor Sie sie brauchen." },
        ],
        features: ["Transparenz der Bestellverpflichtungen", "Lieferantenrisikobewertung", "Konzentrationsanalyse", "Alarme bei Vorlaufzeitabweichung", "Register für Ausweichlieferanten"],
        benefits: ["Frühzeitigere Warnung", "Weniger Eilkosten", "Stärkere Verhandlungsposition", "Vorstandsreife Risikoberichte"],
        outcomes: [{ value: "30 Tage", label: "Typische Frühwarnung" }, { value: "-27 %", label: "Eilkosten" }, { value: "1 Ansicht", label: "Über jede Ebene" }],
        ctaLabel: "Ihr Risiko bewerten",
        relatedLabel: "Lieferantenleistung",
      },
    },
    solutionKicker: "Lösung",
    problemLabel: "Das Problem",
    approachLabel: "Der Mercoris-Ansatz",
    featuresLabel: "Funktionen",
    benefitsLabel: "Vorteile",
    cta: {
      title: "Nicht sicher, welches Programm passt?",
      body: "Schicken Sie uns den Prozess, der Ihr Team am meisten frustriert. Wir bilden ihn auf diese Lösungen ab und sagen Ihnen ehrlich, wo sich der Aufwand lohnt — und wo nicht.",
      primaryLabel: "Mit einem Spezialisten sprechen",
    },
  },

  sourceToPay: {
    hero: {
      breadcrumb: "Source to Pay",
      trustChip1Prefix: "Vertraut von",
      trustChip1Strong: "200+",
      trustChip1Suffix: "Unternehmen",
      trustChip2Strong: "Live in Wochen",
      trustChip2Suffix: ", nicht Monaten",
      titlePrefix: "Verkürzen Sie Sourcing-Zyklen um bis zu 80 % mit unserer",
      titleAccent: "KI-basierten Source-to-Pay-Plattform",
      lede: "Eine einheitliche, unternehmensreife Plattform über den gesamten Sourcing-to-Payment-Lebenszyklus, die Folgendes liefert:",
      walkthroughButton: "Rundgang buchen",
      jumpToModules: "Zu den Modulen springen",
    },
    heroPoints: [
      { label: "Durchgängige Zusammenarbeit mit Lieferanten" },
      { label: "Echtzeit-Analytik" },
      { label: "Budgetkontrolle" },
      { label: "Lieferanten-Compliance-Management" },
      { label: "Integriert mit SAP, Oracle, Dynamics, Workday und anderen ERP-Systemen" },
    ],
    lifecycle: {
      kicker: "Der Ablauf",
      title: "Sechs Phasen, keine Übergabelücken",
      lede: "Jede Phase übernimmt Daten, Dokumente und Freigaben aus der vorherigen. Der Prüfpfad entsteht während der Arbeit, nicht nachträglich zusammengestellt.",
    },
    stages: [
      { name: "Sourcing", body: "Erfassung, RFQ-Ereignisse, umgekehrte Auktionen und strukturierte Vergabeentscheidungen.", metric: "38 % schnellere Ereignisse" },
      { name: "Qualifizieren", body: "Screening, Bewertung, Onboarding und laufende Compliance-Überwachung.", metric: "9 Tage bis zur Qualifikation" },
      { name: "Vertrag", body: "Geführte Erstellung, Klauselbibliotheken, E-Signatur und Verpflichtungen.", metric: "11 Tage bis zur Unterschrift" },
      { name: "Einkauf", body: "Anforderungen, Budgetprüfungen, Freigaben und automatischer Bestellversand.", metric: "1,4 Tage bis zur Bestellung" },
      { name: "Wareneingang", body: "Mobiler Wareneingang, Qualitätsergebnisse und sofortige Abgleichauslöser.", metric: "98 % am selben Tag" },
      { name: "Zahlung", body: "KI-Abgleich, Ausnahmebehandlung, Begleichung und Ausgabenanalyse.", metric: "88 % automatisch" },
    ],
    ai: {
      kicker: "KI-gestützte Beschaffung",
      title: "Die Engine arbeitet die Warteschlange ab, während Ihr Team an der Strategie arbeitet",
      lede: "Mercoris KI liest die Dokumente, wendet Ihre Toleranzen an und eskaliert nur, was wirklich einen Menschen braucht. Konfidenzschwellen legen Sie selbst fest, je Kategorie und Gesellschaft.",
      queueTitle: "Ausnahmewarteschlange",
      queueMeta: "automatisch priorisiert",
    },
    aiTags: ["Dokumentenextraktion", "Drei-Wege-Abgleich", "Duplikaterkennung", "Lieferantenempfehlung", "Angebotszusammenfassung", "Ausgabenklassifizierung", "Verlängerungshinweise", "Anomalie-Bewertung"],
    exceptionQueue: [
      { text: "Preisabweichung 1.240 € über Vertragspreis", badge: "Prüfen", warm: true },
      { text: "Mengenabweichung zum Wareneingang", badge: "Offen", warm: true },
      { text: "Möglicherweise doppelt zu INV-4390", badge: "Alarm", warm: true },
      { text: "Innerhalb der Toleranz — automatisch gebucht", badge: "Erledigt", warm: false },
      { text: "Fehlende Bestellreferenz, Lieferant benachrichtigt", badge: "Nachfassen", warm: true },
    ],
    benefitsTitle: "Was sich in den ersten zwei Quartalen ändert",
    benefits: [
      { title: "Kosten pro Transaktion sinken", body: "Manuelle Eingriffe verschwinden aus Rechnungen, Bestellungen und Lieferantenverwaltung — die Kreditorenbuchhaltung hört auf nachzufassen und beginnt, Ausnahmen zu prüfen." },
      { title: "Einsparungen kommen tatsächlich an", body: "Verhandelte Preise werden bei der Anforderung durchgesetzt, sodass Vertragspreise im Hauptbuch statt nur im Business Case erscheinen." },
      { title: "Risiko überrascht Sie nicht mehr", body: "Ablaufende Zertifikate, Sanktionstreffer und Single-Source-Abhängigkeiten werden Wochen sichtbar, bevor sie zu Vorfällen werden." },
      { title: "Prüfungen werden langweilig", body: "Jede Freigabe, jedes Dokument und jede KI-Entscheidung ist mit Zeitstempel versehen und exportierbar, sodass Nachweisanfragen Minuten dauern." },
    ],
    modules: {
      "vendor-onboarding": {
        kicker: "Lieferanten onboarden sich selbst — korrekt.",
        name: "Lieferanten-Onboarding",
        body: "Ein geführtes Portal erfasst Steuer-, Bank-, Compliance- und Diversitätsdaten mit Validierung bei der Eingabe — sodass nichts an den Einkauf zurückgeht und der Lieferantendatensatz sauber im ERP landet.",
        bullets: ["Gebrandetes Selbstbedienungsportal", "Länderspezifische Steuervalidierung", "Duplikaterkennung bei Erstellung", "Direkte Lieferantenerstellung im ERP"],
        panelTitle: "Onboarding-Tracker", panelMeta: "diese Woche",
        rows: [
          { label: "Einladung gesendet", value: "42 Lieferanten", pill: "Gesendet", warm: false },
          { label: "Angaben eingereicht", value: "36 Lieferanten", pill: "Aktiv", warm: false },
          { label: "Compliance-Prüfung", value: "31 Lieferanten", pill: "Automatisch", warm: false },
          { label: "ERP angelegt", value: "29 Lieferanten", pill: "Erledigt", warm: false },
        ],
        statA: "72 %", statALabel: "Weniger Rückfragen", statB: "3 Tage", statBLabel: "Einladung bis aktiv",
      },
      "purchase-requisition": {
        kicker: "Erfassung, die Einkäufer auf den richtigen Weg führt.",
        name: "Bestellanforderung",
        body: "Ein Anfrageformular leitet automatisch an Katalog, Vertrag oder Sourcing weiter, prüft das Budget in Echtzeit und holt die von der Richtlinie geforderten Freigaben ein.",
        bullets: ["Geführte Erfassung mit Kategorielogik", "Echtzeit-Budget- und Verpflichtungsprüfung", "Durchsetzung von Vollmachten", "Mobile Freigaben mit vollem Kontext"],
        panelTitle: "Anforderung REQ-88213", panelMeta: "24.500 €",
        rows: [
          { label: "Budgetprüfung", value: "Kostenstelle 4410", pill: "Bestanden", warm: false },
          { label: "Vertragsabgleich", value: "MSA-2024-17", pill: "Gefunden", warm: false },
          { label: "Genehmiger 1", value: "Vorgesetzter", pill: "Genehmigt", warm: false },
          { label: "Genehmiger 2", value: "Finanzen", pill: "Ausstehend", warm: true },
        ],
        statA: "1,4 Tage", statALabel: "Anforderung bis Bestellung", statB: "96 %", statBLabel: "Beim ersten Mal korrekt",
      },
      "purchase-order": {
        kicker: "Bestellungen, ausgegeben in dem Moment, in dem die Freigabe eintrifft.",
        name: "Bestellung",
        body: "Bestellungen entstehen aus genehmigten Anforderungen, Verträgen oder Katalog-Warenkörben, werden im bevorzugten Format an Lieferanten versendet und in ihrer Bestätigung nachverfolgt.",
        bullets: ["Automatische Bestellerstellung und -versand", "Zustellung per cXML, EDI, E-Mail und Portal", "Änderungsaufträge mit Versionshistorie", "Bestätigungs- und Liefertermin-Tracking"],
        panelTitle: "Offene Bestellungen", panelMeta: "1.846",
        rows: [
          { label: "Bestätigt", value: "1.612 Bestellungen", pill: "82 %", warm: false },
          { label: "Antwort ausstehend", value: "168 Bestellungen", pill: "Nachfassen", warm: true },
          { label: "Änderung angefragt", value: "44 Bestellungen", pill: "Prüfen", warm: true },
          { label: "Lieferung überfällig", value: "22 Bestellungen", pill: "Alarm", warm: true },
        ],
        statA: "< 2 Min.", statALabel: "Freigabe bis Versand", statB: "82 %", statBLabel: "Automatisch bestätigt",
      },
      "e-auctions": {
        kicker: "Den Markt den Preis finden lassen.",
        name: "E-Auktionen",
        body: "Umgekehrte und vorwärtsgerichtete Auktionen durchführen — englisch, holländisch, japanisch und rangbasiert — mit Live-Ranglisten, Anti-Sniping-Verlängerungen und vollständiger Gebotshistorie für die Prüfung.",
        bullets: ["Umgekehrte und vorwärtsgerichtete Auktionsformate", "Live-Rang- und Preisrückmeldung", "Automatische Zeitverlängerungen", "Vollständiges Gebots-Prüfprotokoll"],
        panelTitle: "Auktion AUC-114", panelMeta: "live · 04:12",
        rows: [
          { label: "Bieter A", value: "412.000 €", pill: "Rang 1", warm: false },
          { label: "Bieter C", value: "418.500 €", pill: "Rang 2", warm: false },
          { label: "Bieter B", value: "421.000 €", pill: "Rang 3", warm: false },
          { label: "Einsparung ggü. Basiswert", value: "63.400 €", pill: "13,3 %", warm: false },
        ],
        statA: "13,3 %", statALabel: "Typische Ereigniseinsparung", statB: "42 Min.", statBLabel: "Mediane Dauer",
      },
      "request-for-quotation": {
        kicker: "Strukturierte Sourcing-Ereignisse ohne Tabellenkalkulation.",
        name: "Angebotsanfrage",
        body: "Ereignisse aus Vorlagen erstellen, qualifizierte Lieferanten einladen, versiegelte Antworten sammeln und wie mit wie in einer normalisierten Angebotsauswertung vergleichen.",
        bullets: ["Mehrrundige, mehrlosige Ereignisse", "Versiegelte Gebote mit zeitgesteuerter Freigabe", "Automatische Gebotsnormalisierung", "KI-entworfene Leistungsbeschreibungen und Fragen"],
        panelTitle: "Ereignis RFQ-2291", panelMeta: "8 Bieter",
        rows: [
          { label: "Los 1 — Gussteile", value: "6 Antworten", pill: "Offen", warm: true },
          { label: "Los 2 — Bearbeitung", value: "8 Antworten", pill: "Offen", warm: true },
          { label: "Los 3 — Beschichtung", value: "5 Antworten", pill: "Geschlossen", warm: false },
          { label: "Vergabeempfehlung", value: "KI-Entwurf bereit", pill: "Neu", warm: true },
        ],
        statA: "38 %", statALabel: "Schnellerer Ereigniszyklus", statB: "6,4 %", statBLabel: "Durchschnittliche Einsparung",
      },
      "service-entry-sheet": {
        kicker: "Leistungsnachweis, dort abgezeichnet, wo er entsteht.",
        name: "Leistungserfassungsblatt",
        body: "Dienstleister erfassen Aufwand gegen die Dienstleistungsbestellung, Standortverantwortliche bestätigen ihn mobil, und das genehmigte Erfassungsblatt gibt die Rechnung frei — keine Papier-Stundenzettel dazwischen.",
        bullets: ["Aufwandserfassung gegen Dienstleistungsbestellungen", "Validierung von Preislisten und Meilensteinen", "Mobile Standortfreigabe", "Automatische Freigabe an die Rechnungsstellung"],
        panelTitle: "Leistungserfassungen", panelMeta: "Woche 30",
        rows: [
          { label: "Eingereicht", value: "148 Einträge", pill: "Offen", warm: true },
          { label: "Standort genehmigt", value: "121 Einträge", pill: "Erledigt", warm: false },
          { label: "Preisabweichung", value: "9 Einträge", pill: "Prüfen", warm: true },
          { label: "An Kreditorenbuchhaltung freigegeben", value: "121 Einträge", pill: "Automatisch", warm: false },
        ],
        statA: "82 %", statALabel: "Genehmigt innerhalb von 24 Std.", statB: "4,1 %", statBLabel: "Preisabweichung erkannt",
      },
      "advance-shipping-notice": {
        kicker: "Wissen, was ankommt, bevor es ankommt.",
        name: "Vorabversandbenachrichtigung",
        body: "Lieferanten veröffentlichen Versanddetails — Mengen, Chargen, Verpackung und voraussichtliche Ankunft —, damit Wareneingangsstellen vorausplanen und Wareneingänge einer bekannten Sendung zugeordnet werden.",
        bullets: ["Vom Lieferanten veröffentlichte Versanddaten", "Chargen-, Serien- und Verpackungsdetails", "Änderungen der voraussichtlichen Ankunft an Planer übermittelt", "Vorab mit Bestellpositionen abgeglichen"],
        panelTitle: "Eingehende Sendungen", panelMeta: "nächste 7 Tage",
        rows: [
          { label: "Im Zeitplan", value: "212 Sendungen", pill: "OK", warm: false },
          { label: "Verzögert", value: "18 Sendungen", pill: "Alarm", warm: true },
          { label: "Teilversand", value: "24 Sendungen", pill: "Prüfen", warm: true },
          { label: "Heute ankommend", value: "37 Sendungen", pill: "—", warm: false },
        ],
        statA: "91 %", statALabel: "Sendungen mit Vorabbenachrichtigung", statB: "2,4 Tage", statBLabel: "Vorlaufsichtbarkeit",
      },
      "goods-receipt-note": {
        kicker: "Wareneingänge dort erfasst, wo die Ware ankommt.",
        name: "Wareneingang",
        body: "Lager- und Standortteams bestätigen Mengen, erfassen Qualitätsergebnisse und hängen Fotos vom Mobilgerät an — und speisen so sofort Abgleich und Lieferanten-Scorecards.",
        bullets: ["Mobile und Barcode-Erfassung", "Regeln für Teil- und Überlieferung", "Qualitätsprüfungsergebnisse", "Automatischer Drei-Wege-Abgleichauslöser"],
        panelTitle: "Wareneingänge heute", panelMeta: "128 Positionen",
        rows: [
          { label: "Vollständiger Eingang", value: "104 Positionen", pill: "Abgeglichen", warm: false },
          { label: "Teilweise", value: "16 Positionen", pill: "Offen", warm: true },
          { label: "Qualitätssperre", value: "5 Positionen", pill: "Gesperrt", warm: true },
          { label: "Zurückgewiesen", value: "3 Positionen", pill: "Retoure", warm: true },
        ],
        statA: "98 %", statALabel: "Wareneingänge am selben Tag", statB: "2,1 %", statBLabel: "Quote Qualitätssperren",
      },
      invoice: {
        kicker: "Automatisch vom Eingang bis zur Zahlungsdatei.",
        name: "Rechnung",
        body: "Rechnungen kommen per E-Mail, Portal oder EDI an, werden von der KI-Engine gelesen, mit Bestellung und Wareneingang abgeglichen und ohne Mensch gebucht, außer etwas stimmt nicht.",
        bullets: ["KI-Extraktion mit Konfidenzbewertung", "Zwei- und Drei-Wege-Abgleichstoleranzen", "Duplikat- und Betrugserkennung", "Erfassung von Skonto bei früher Zahlung"],
        panelTitle: "Rechnungslauf", panelMeta: "heute",
        rows: [
          { label: "Erhalten", value: "1.382 Rechnungen", pill: "—", warm: false },
          { label: "Automatisch abgeglichen", value: "1.204 Rechnungen", pill: "88 %", warm: false },
          { label: "Ausnahmen", value: "178 Rechnungen", pill: "Warteschlange", warm: true },
          { label: "Skonto erfasst", value: "41.200 €", pill: "Erhalten", warm: false },
        ],
        statA: "88 %", statALabel: "Durchgängige Quote", statB: "0,94 $", statBLabel: "Kosten pro Rechnung",
      },
      "contract-management": {
        kicker: "Ein Repository, das wirklich weiß, was es enthält.",
        name: "Vertragsmanagement",
        body: "Klauselbibliotheken, geführte Erstellung, E-Signatur und Verpflichtungsverfolgung — mit KI, die Risikosprache, Verlängerungstermine und Preiseskalatoren aufzeigt.",
        bullets: ["Klauselbibliothek mit Freigabe-Routing", "KI-Klauselextraktion und Risikokennzeichen", "Verpflichtungs- und Meilensteinverfolgung", "Verlängerungs- und Eskalationshinweise"],
        panelTitle: "Vertragsarchiv", panelMeta: "3.410 aktiv",
        rows: [
          { label: "Läuft in 30 Tagen aus", value: "12 Verträge", pill: "Handeln", warm: true },
          { label: "Automatische Verlängerungsklauseln", value: "184 Verträge", pill: "Beobachten", warm: true },
          { label: "Nicht standardisierte Bedingungen", value: "27 Verträge", pill: "Rechtlich", warm: true },
          { label: "Fällige Verpflichtungen", value: "58 Positionen", pill: "Verantwortlich", warm: false },
        ],
        statA: "310.000 $", statALabel: "Vermiedener Verlust", statB: "11 Tage", statBLabel: "Schneller zur Unterschrift",
      },
      "supplier-bulletin-management": {
        kicker: "Ein Kanal für Ihre gesamte Lieferantenbasis.",
        name: "Lieferanten-Mitteilungsmanagement",
        body: "Richtlinienaktualisierungen, Preisanfragen, Betriebsferienkalender und dringende Mitteilungen an gezielte Lieferantensegmente veröffentlichen — mit Lesebestätigungen und Nachverfolgung.",
        bullets: ["Segmentierte Lieferanten-Verteilerlisten", "Bestätigungs- und Lesenachverfolgung", "Geplante und wiederkehrende Mitteilungen", "Zustellung per Portal, E-Mail und API"],
        panelTitle: "Mitteilung BUL-118", panelMeta: "Dienstag gesendet",
        rows: [
          { label: "Zugestellt", value: "2.140 Lieferanten", pill: "Erledigt", warm: false },
          { label: "Geöffnet", value: "1.806 Lieferanten", pill: "84 %", warm: false },
          { label: "Bestätigt", value: "1.522 Lieferanten", pill: "71 %", warm: false },
          { label: "Keine Antwort", value: "334 Lieferanten", pill: "Nachfassen", warm: true },
        ],
        statA: "84 %", statALabel: "Öffnungsrate", statB: "0", statBLabel: "Zu pflegende Verteilerlisten",
      },
      "supplier-compliance-management": {
        kicker: "Compliance, die überwacht, nicht nur protokolliert.",
        name: "Lieferanten-Compliance-Management",
        body: "Zertifikate, Richtlinien, Sanktionslisten und ESG-Erklärungen laufend überwacht, mit automatischer Eskalation in dem Moment, in dem etwas abläuft.",
        bullets: ["Laufendes Sanktions- und PEP-Screening", "Automatisierung des Zertifikatsablaufs", "Nachverfolgung von Richtlinienbestätigungen", "Export prüfbereiter Nachweispakete"],
        panelTitle: "Compliance-Monitor", panelMeta: "live",
        rows: [
          { label: "ISO-9001-Zertifikate", value: "1.204 gültig", pill: "OK", warm: false },
          { label: "Versicherungspolicen", value: "18 laufen ab", pill: "Alarm", warm: true },
          { label: "Sanktionsscreening", value: "12.480 geprüft", pill: "Unauffällig", warm: false },
          { label: "Verhaltenskodex", value: "97 % unterzeichnet", pill: "OK", warm: false },
        ],
        statA: "24 Std.", statALabel: "Ablauferkennung", statB: "100 %", statBLabel: "Nachweise erhalten",
      },
      "supplier-performance-management": {
        kicker: "Scorecards, die sich selbst erstellen.",
        name: "Lieferantenleistungsmanagement",
        body: "Lieferung, Qualität, Reaktionsfähigkeit und Compliance direkt aus Transaktionen gezogen — nach Ihrer Gewichtung, in Ihrem Rhythmus geprüft.",
        bullets: ["Automatisierte KPI-Erfassung aus Transaktionen", "Gewichtete Kategorie-Scorecards", "Verbesserungspläne mit Verantwortlichen", "Vierteljährliche Geschäftsreview-Pakete"],
        panelTitle: "Scorecard Q3", panelMeta: "Top-Lieferanten",
        rows: [
          { label: "Termingerechte Lieferung", value: "94,2 %", pill: "▲", warm: false },
          { label: "Qualitätsannahme", value: "98,7 %", pill: "▲", warm: false },
          { label: "Reaktionsfähigkeit", value: "88,0 %", pill: "▼", warm: false },
          { label: "Compliance", value: "100 %", pill: "=", warm: false },
        ],
        statA: "94,2 %", statALabel: "Termingerechte Lieferung", statB: "+7 Pkt.", statBLabel: "Im Jahresvergleich",
      },
      "supply-chain-issue-management": {
        kicker: "Störungen bis zum Abschluss verfolgt, nicht bis zum Posteingang.",
        name: "Störungsmanagement in der Lieferkette",
        body: "Engpässe, Qualitätsmängel, Verzögerungen und Logistikausfälle als strukturierte Fälle mit Verantwortlichen, Schweregrad, Ursache und Korrekturmaßnahmen erfasst — für beide Seiten sichtbar.",
        bullets: ["Strukturierte Fallerfassung und -triage", "Schweregradbasierte SLAs und Eskalation", "8D- und Ursachenanalyse-Workflows", "Gemeinsame Lösungsansicht mit dem Lieferanten"],
        panelTitle: "Offene Vorfälle", panelMeta: "live",
        rows: [
          { label: "Kritisch", value: "3 Fälle", pill: "Alarm", warm: true },
          { label: "Lieferverzögerung", value: "21 Fälle", pill: "Offen", warm: true },
          { label: "Qualitätsmangel", value: "14 Fälle", pill: "Prüfen", warm: true },
          { label: "Diesen Monat geschlossen", value: "96 Fälle", pill: "Erledigt", warm: false },
        ],
        statA: "3,2 Tage", statALabel: "Mediane Lösungszeit", statB: "68 %", statBLabel: "Wiederholung vermieden",
      },
      "supplier-certification": {
        kicker: "Zertifikate, die von selbst aktuell bleiben.",
        name: "Lieferantenzertifizierung",
        body: "Qualitäts-, Sicherheits-, Versicherungs- und ESG-Zertifizierungen mit Ablaufautomatisierung sammeln, validieren und erneut prüfen — sodass ein veraltetes Dokument nie eine Vergabeentscheidung erreicht.",
        bullets: ["Zertifikatssammlung und -validierung", "Automatisierte Ablauf- und Verlängerungsnachverfolgung", "Kategoriespezifische Anforderungssätze", "Sperrregeln bei Vergabe und Bestellung"],
        panelTitle: "Zertifizierungsregister", panelMeta: "12.480 Lieferanten",
        rows: [
          { label: "Gültig", value: "11.402 Lieferanten", pill: "OK", warm: false },
          { label: "Läuft in 30 Tagen ab", value: "612 Lieferanten", pill: "Nachfassen", warm: true },
          { label: "Abgelaufen", value: "184 Lieferanten", pill: "Alarm", warm: true },
          { label: "Validierung ausstehend", value: "282 Lieferanten", pill: "Prüfen", warm: true },
        ],
        statA: "91 %", statALabel: "Zertifikate aktuell", statB: "0", statBLabel: "Manuelle Erinnerungs-E-Mails",
      },
      "supplier-rating": {
        kicker: "Eine Kennzahl, der Ihre Kategoriemanager vertrauen.",
        name: "Lieferantenbewertung",
        body: "Gewichtete Bewertungen fassen Leistung, Compliance, Risiko und kommerzielle Daten zu einem vergleichbaren Wert zusammen — für Lieferanten veröffentlicht und in Vergabeentscheidungen genutzt.",
        bullets: ["Konfigurierbare Gewichtung je Kategorie", "Bewertungshistorie und Trendlinien", "Für Lieferanten sichtbare Bewertungsaufschlüsselung", "Bewertungsschwellen in Sourcing-Regeln"],
        panelTitle: "Kategoriebewertungen", panelMeta: "Q3",
        rows: [
          { label: "Kernwerk GmbH", value: "A · 92", pill: "▲", warm: false },
          { label: "Voltara Energy", value: "A · 89", pill: "=", warm: false },
          { label: "Sumira Polymers", value: "B · 74", pill: "▼", warm: false },
          { label: "Brightpath Labs", value: "C · 61", pill: "Prüfen", warm: true },
        ],
        statA: "16", statALabel: "Höhergestufte Lieferanten", statB: "4", statBLabel: "Ausgelistete Lieferanten",
      },
    },
    analytics: {
      kicker: "Analytics & Dashboards",
      title: "Jede Phase standardmäßig instrumentiert",
      lede: "Durchlaufzeit, Einsparungsrealisierung, Compliance und Lieferantenrisiko aktualisieren sich mit jeder Transaktion. Nach Gesellschaft, Kategorie, Einkäufer oder Lieferant aufschlüsseln — und an die richtigen Personen verteilen.",
    },
    analyticsCards: [
      { title: "Durchlaufzeit-Analytik", body: "Phase-für-Phase-Dauer mit Engpasserkennung nach Team, Kategorie und Gesellschaft." },
      { title: "Einsparungsrealisierung", body: "Identifizierte, verhandelte und realisierte Einsparungen bis zum Hauptbuch nachverfolgt." },
      { title: "Compliance-Dashboard", body: "Vertragskonformer Einkauf, Richtlinienverstöße und Freigabeausnahmen in einer Ansicht." },
      { title: "Lieferantenrisikoansicht", body: "Konzentration, Geografie, finanzielle Gesundheit und Zertifikatsstatus kombiniert." },
      { title: "Working Capital", body: "Zahlungsbedingungen, Skonto-Erfassung und DPO-Modellierung nach Lieferantensegment." },
      { title: "Geplante Berichte", body: "Vorstandsreife Pakete, zugestellt nach Ihrem Berichtskalender." },
    ],
    enterpriseFeaturesTitle: "Enterprise-Funktionen",
    enterpriseFeatures: [
      { title: "Mehrere Gesellschaften und Währungen", body: "Separate Rechtsträger, Steuerlogik und Berichtswährungen in einem Mandanten." },
      { title: "Konfigurierbare Freigabematrix", body: "Schwellenwerte, Delegation und Funktionstrennung ohne Codeänderungen." },
      { title: "Lokalisierung", body: "Oberfläche, Dokumente und Lieferantenportal in Ihren Betriebssprachen." },
      { title: "Optionen zur Datenresidenz", body: "Hosting in EU, USA, UK, VAE und Indien ohne regionsübergreifende Verarbeitung." },
      { title: "Sandbox- und Release-Kontrolle", body: "Konfigurationsänderungen testen, dann mit vollständigem Änderungsprotokoll befördern." },
      { title: "Enterprise-Support", body: "Benannter Architekt, 24/7-Abdeckung und eine Verfügbarkeitszusage von 99,95 %." },
    ],
    connectedTitle: "Verbunden mit Ihrer IT-Landschaft",
    connectedLede: "Bidirektionale Synchronisierung mit ERP-Stammdaten, Hauptbuch, Budgets und Zahlungsläufen. Zertifizierte Connectoren oder eigene Entwicklung auf der offenen API.",
    integrations: ["SAP S/4HANA", "Oracle Fusion", "NetSuite", "Dynamics 365", "Workday", "Coupa", "DocuSign", "Snowflake", "Power BI", "Azure AD", "EDI / cXML", "REST & Webhooks"],
    seeApis: "Plattform-APIs ansehen",
    cta: {
      title: "Mit einem Modul beginnen. Den Rest warten lassen",
      body: "Die meisten Teams beginnen mit Rechnungen oder Lieferanten-Onboarding und erweitern von dort aus. Wir zeigen Ihnen den kürzesten Weg zu einem messbaren Erfolg.",
      primaryLabel: "Rundgang buchen",
    },
  },

  contact: {
    breadcrumb: "Kontakt",
    hero: {
      title: "Transformieren Sie Ihre",
      titleLine2: "Beschaffungsstrategie",
      lede: "Möchten Sie sehen, wie Mercoris zu Ihren Geschäftsanforderungen passt, oder eine kurze Demo erleben? Sprechen Sie mit uns.",
    },
    intents: [
      { title: "Die richtige Lösung finden", body: "Besprechen Sie die beste Mercoris-Lösung für Ihre Geschäftsziele, Arbeitsabläufe und Einkaufsprioritäten." },
      { title: "Den gesamten Zyklus sehen", body: "Entdecken Sie, wie all unsere Source-to-Pay-Apps zusammenwirken, um einen vollständigen Sourcing-Zyklus zu liefern." },
      { title: "Maßgeschneiderte Preise erhalten", body: "Preise basierend auf Ihrer Unternehmensgröße und den Source-to-Pay-Funktionen, die Sie tatsächlich benötigen." },
    ],
    getInTouch: "Kontakt aufnehmen",
    phoneLabel: "Telefon",
    emailLabel: "E-Mail-Adresse",
    emailNote: "Jede Anfrage wird von einem Spezialisten gelesen — wir antworten innerhalb eines Werktags.",
    offices: {
      US: { country: "USA" },
      DE: { country: "Deutschland" },
      IN: { country: "Indien" },
    },
    faqTitle: "Häufig gestellte Fragen",
    faqs: [
      { q: "Wie lange dauert eine Mercoris-Implementierung?", a: "Ein erstes Modul im Produktivbetrieb dauert mit Ihren Daten und Freigaberegeln typischerweise sechs Wochen. Vollständiges Source-to-Pay über mehrere Gesellschaften ist meist ein gestuftes Programm von sechs bis neun Monaten, mit Wertschöpfung in jeder Phase statt erst am Ende." },
      { q: "Kann Mercoris neben unserem bestehenden ERP arbeiten?", a: "Ja. Mercoris ist so konzipiert, dass es dem ERP vorgelagert ist, nicht es ersetzt. Zertifizierte Connectoren verarbeiten Lieferantenstammdaten, Kostenstellen, Budgets, Sachkonten und Zahlungsläufe bidirektional, und die offene REST-API deckt alles ab, was ein Connector nicht abdeckt." },
      { q: "Bieten Sie ein Pilotprojekt an?", a: "Wir führen kostenpflichtige Proof-of-Value-Projekte für eine Kategorie oder einen Prozess durch, mit Ihren echten Daten in einem isolierten Mandanten. Wenn die vereinbarten Kennzahlen nicht erreicht werden, erhalten Sie die Analyse ohne Plattformverpflichtung." },
      { q: "Wie werden unsere Daten geschützt?", a: "Zertifizierte Kontrollen nach ISO 27001 und SOC 2 Type II, AES-256-Verschlüsselung im Ruhezustand, TLS 1.3 bei der Übertragung, regionale Datenresidenz und optionale kundenverwaltete Schlüssel. Ihre Daten werden nie zum Training von Modellen verwendet." },
      { q: "Wie sehen die Preise aus?", a: "Plattform-Abonnement basierend auf eingesetzten Modulen und Transaktionsvolumen, mit unbegrenzten internen Nutzern und ohne Gebühr für Lieferantenkonten. Wir geben Ihnen im ersten Gespräch eine indikative Spanne." },
      { q: "Mit wem arbeiten wir tatsächlich zusammen?", a: "Ein benannter Lösungsarchitekt von der Analyse bis zum Go-live, unterstützt von einem Delivery-Team, das auch in der Hypercare-Phase an Ihrer Seite bleibt. Enterprise-Pläne beinhalten 24/7-Support und ein vierteljährliches Service-Review." },
    ],
    form: {
      nameLabel: "Vollständiger Name",
      namePlaceholder: "Geben Sie Ihren vollständigen Namen ein",
      companyLabel: "Unternehmen",
      companyHint: "(optional)",
      companyPlaceholder: "Geben Sie Ihren Firmennamen ein",
      emailLabel: "E-Mail-Adresse",
      emailPlaceholder: "Geben Sie Ihre E-Mail-Adresse ein",
      phoneLabel: "Telefonnummer",
      phonePlaceholder: "Geben Sie Ihre Telefonnummer ein",
      messageLabel: "Wie können wir Ihnen helfen?",
      messagePlaceholder: "Erzählen Sie uns von Ihrem Anliegen",
      submit: "Absenden",
      submitting: "Wird gesendet…",
      errors: {
        name: "Bitte teilen Sie uns Ihren Namen mit.",
        emailRequired: "Bitte geben Sie eine geschäftliche E-Mail-Adresse an.",
        emailInvalid: "Diese E-Mail-Adresse sieht nicht korrekt aus.",
        phoneRequired: "Bitte geben Sie eine Telefonnummer an.",
        phoneInvalid: "Verwenden Sie Ziffern, Leerzeichen und optional ein +.",
        message: "Ein oder zwei Sätze helfen uns, Ihre Anfrage richtig zuzuordnen.",
      },
      statusInvalid: "Bitte überprüfen Sie die markierten Felder und versuchen Sie es erneut.",
      statusSuccess: "Vielen Dank — Ihre Nachricht ist bei uns eingegangen. Ein Beschaffungsspezialist antwortet innerhalb eines Werktags.",
      statusError: "Das konnten wir gerade nicht senden. Bitte versuchen Sie es erneut oder schreiben Sie an contact@sigvion.com.",
    },
  },

  notFound: {
    kicker: "404",
    title: "Diese Seite wurde verschoben oder hat nie existiert",
    lede: "Probieren Sie die Source-to-Pay-Suite, die Plattform-Tour, oder sagen Sie uns, wonach Sie gesucht haben.",
    backHome: "Zurück zur Startseite",
    contactUs: "Kontakt aufnehmen",
  },
};

export default de;
